// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QFtSO5faG6aq2cSIOVh7 {
	align-items: center;
	background-position: center;
	background-repeat: no-repeat;
    background-size: cover;
    border-radius: 12px;
	display: flex;
	justify-content: space-between;
    padding: 16px 24px;
}

.c_cGg2YVZXp8Gon7RBK0 {
    font-size: 13px !important;
    line-height: 18px !important;
}

.c_cGg2YVZXp8Gon7RBK0 {
    font-weight: 400;
    letter-spacing: -0.08em;   
    max-width: 450px;
}

.am0NawUfVLAIm8kCc0c9 {
    width: 100%;
}

.xzRnTSzjML36FUHI0Au6 {
    margin-right: 24px;
    min-width: 26px;
}

.KEYvrIpFgj9PexMoTkV9, .c_cGg2YVZXp8Gon7RBK0, .DkaNqtViSwpnW4B8x4d6 {
	color: #EFDEFC;
}

.KEYvrIpFgj9PexMoTkV9 {
    font-weight: 400;
    letter-spacing: -0.08em;
}

.QSZ3SS3x7o57FjSJJ_qt {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
}

.bxXF9mbzJ_InfQcxjHXV {
    background: rgba(0, 0, 0, 0.72);
    border-radius: 8px;
    max-width: 276px;
}

.DkaNqtViSwpnW4B8x4d6:hover {
    cursor: pointer;
}

`, "",{"version":3,"sources":["webpack://./src/components/Banner/Banner.pcss"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,2BAA2B;CAC3B,4BAA4B;IACzB,sBAAsB;IACtB,mBAAmB;CACtB,aAAa;CACb,8BAA8B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAG1B,4BAA4B;AAEhC;;AANA;IAEI,gBAAgB;IAChB,uBAAuB;IAEvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".container {\n\talign-items: center;\n\tbackground-position: center;\n\tbackground-repeat: no-repeat;\n    background-size: cover;\n    border-radius: 12px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n    padding: 16px 24px;\n}\n\n.description {\n    font-size: 13px !important;\n    font-weight: 400;\n    letter-spacing: -0.08em;\n    line-height: 18px !important;   \n    max-width: 450px;\n}\n\n.fullWidth {\n    width: 100%;\n}\n\n.icon {\n    margin-right: 24px;\n    min-width: 26px;\n}\n\n.title, .description, .question {\n\tcolor: #EFDEFC;\n}\n\n.title {\n    font-weight: 400;\n    letter-spacing: -0.08em;\n}\n\n.titleContainer {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 6px;\n}\n\n.tooltip {\n    background: rgba(0, 0, 0, 0.72);\n    border-radius: 8px;\n    max-width: 276px;\n}\n\n.question:hover {\n    cursor: pointer;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `QFtSO5faG6aq2cSIOVh7`,
	"description": `c_cGg2YVZXp8Gon7RBK0`,
	"fullWidth": `am0NawUfVLAIm8kCc0c9`,
	"icon": `xzRnTSzjML36FUHI0Au6`,
	"title": `KEYvrIpFgj9PexMoTkV9`,
	"question": `DkaNqtViSwpnW4B8x4d6`,
	"titleContainer": `QSZ3SS3x7o57FjSJJ_qt`,
	"tooltip": `bxXF9mbzJ_InfQcxjHXV`
};
export default ___CSS_LOADER_EXPORT___;
